export default __webpack_public_path__ + "static/RobotoMono-Regular-473137234b890954c09c2ad66904e8cc.ttf";